module.exports = __webpack_public_path__ + "img/device.e301eec1.svg";